export const state = {
  loading: false,
}

export const getters = {}

export const mutations = {
  isLoading(state, value) {
    state.loading = value
  }
}

export const actions = {
}
